module.exports = __webpack_public_path__ + "img/2usbit.926fc43d.png";